import createSelector from 'lib/web/createSelector'
import config from 'constants/config'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'
import { isSpoofed } from 'selectors/featuresSelectors'

export const isLuxuryPlusEnabled = createSelector(
  isSpoofed,
  (state: App.State) => state.loyalty.member.subscription.item,
  (state: App.State) => state.geo.currentRegionCode,
  (isSpoofed, memberSubscriptionItem, currentRegion): boolean => {
    if (!config.LUXURY_PLUS_ENABLED) {
      return false
    }

    const isLuxPlusDarkLaunchRegion = isEnabledForFeature(config.LUXURY_PLUS_DARK_LAUNCH_REGIONS, currentRegion)
    if (isSpoofed && isLuxPlusDarkLaunchRegion) {
      return true
    }

    const isLuxPlusLiveRegion = isEnabledForFeature(config.LUXURY_PLUS_LIVE_REGIONS, currentRegion)

    return isLuxPlusLiveRegion || isLuxPlusDarkLaunchRegion && memberSubscriptionItem?.status === 'ACTIVE' && currentRegion === memberSubscriptionItem?.region
  },
)
/**
 * Check if the user is an active Luxury Plus member
 * Takes into account the current region and the user's subscription status
 * Members are only members in the region they bought the subscription in
 */
export const isActiveLuxuryPlusMember = createSelector(
  isLuxuryPlusEnabled,
  (state: App.State) => state.loyalty.member.subscription.item,
  (state: App.State) => state.geo.currentRegionCode,
  (isLuxuryPlusEnabled, memberSubscriptionItem, currentRegion): boolean => {
    return !!(isLuxuryPlusEnabled && memberSubscriptionItem?.status === 'ACTIVE' && currentRegion === memberSubscriptionItem?.region)
  },
)
